<template>
  <section class="page-container">
    <template >
      <h1 class="title-quick">Quick Quote</h1>
    </template>
    <motor-underwirting
      v-if="productId == 11"
      ref="motor-form"
      :form="quickData"
      @getFormData="getFormData" />
    <housemaid-form
      v-if="productId == 12"
      ref="housemaid-form"
      :form="quickData"
      @getFormData="getFormData" />
    <decoration-form
      v-else-if="productId == 15"
      ref="decoration-form"
      :form="quickData"
      @getFormData="getFormData" />
    <travel-form
      v-else-if="productId == 14"
      ref="homefire-form"
      :form="quickData"
      @getFormData="getFormData" />
    <homefire-form
      v-else-if="productId == 17"
      ref="homefire-form"
      :form="quickData"
      @getFormData="getFormData" />
    <h1 class="title-quick">Underwriting Questions</h1>
    <div class="form-half answer-list">
      <p
        v-for="(item,index) in underwriting"
        :key="index"
        class="answer">
        {{item.name}}
      </p>
      <v-radio-group
        v-model="formData.underwriting_confirm"
        :list="answerList" />
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import HousemaidForm from '@/views/quoting/modules/housemaid/form/underwriting'
import DecorationForm from '@/views/quoting/modules/decoration/form/underwriting'
import HomefireForm from '@/views/quoting/modules/homefire/form/underwriting'
import travelForm from '@/views/quoting/modules/travel/form/underwriting'
import motorUnderwirting from '@/views/quoting/modules/motor/underwirting'
export default {
  name: 'QuickQuote',
  components: {
    HousemaidForm,
    DecorationForm,
    HomefireForm,
    motorUnderwirting,
    travelForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return{
      requireValid:false,
      formData:{
        underwriting_confirm:-1
      },
    }
  },
  computed: {
    productId(){
      return this.form.product_id
    },
    underwriting(){
      let {quick_quote_detail={}} = this.form||{}
      // this.formData.underwriting_confirm = quick_quote_detail.part_of_under_cond
      this.formData.underwriting_confirm = quick_quote_detail.underwriting_confirm
      return quick_quote_detail.underwriting||[]
    },
    quickData(){
      let {quick_quote_detail={},class_id} = this.form||{}
      let params = {
        ...quick_quote_detail,
        class_id
      }
      return params
    }
  },
  methods: {
    submitForm(){
      const formKey = {
        11: 'motor-form',
        12: 'housemaid-form',
        15: 'decoration-form',
        17: 'homefire-form'
      }
      this.$refs[formKey[this.productId]].submitForm()
    },
    getFormData(form) {
      this.formData = Object.assign(this.formData, form)
      this.$emit('submitData',this.formData)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  //padding-bottom: 100px;
  .pd-t {
    padding-top: 20px;
  }
  .title-quick{
    color: #24292E;
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
  }
  .answer{
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 19px;
    margin-bottom: 20px;
  }
  .answer-list{
    ::v-deep .el-radio-group{
      display: flex;
      flex-direction: column;
      label{
        margin-bottom: 15px;
      }
    }
  }

}
</style>